class Field{

  constructor(id,name,lat,lng,city,state,country,address,active){
    this.id = id
    this.name = name || ""
    this.lat = Number(lat) || 0
    this.lng = Number(lng) || 0
    this.city = city || ""
    this.state = state || ""
    this.country = country || ""
    this.address = address || ""
    this.active = active || false
  }


  static parse(responseData){
    if(!responseData){return new Field()}
    let d = responseData
    return new Field(d.id,d.name,d.lat,d.lng,d.city,d.state,d.country,d.address, d.active)
  }
}


export default Field



// WEBPACK FOOTER //
// ./src/models/field.js